<template>
    <div class="scc-prize-alternate" :class="`${hasShadow ? 'scc-prize-alternate--has-shadow' : ''}`">
        <div class="scc-prize-alternate__quantity-outer-container">
            <div
                class="scc-prize-alternate__quantity-container"
                :class="highlight ? 'scc-prize-alternate__quantity-container--highlight' : ''"
            >
                <div class="scc-prize-alternate__quantity h5">{{ quantity }}x</div>
            </div>
        </div>
        <div
            ref="prizeContainer"
            class="scc-prize-alternate__container"
            @mouseover="showContainer = true"
            @mouseleave="showContainer = false"
        >
            <div class="scc-prize-alternate__main-container">
                <div class="scc-prize-alternate__image-container">
                    <div class="scc-prize-alternate__image" :style="[backgroundImage]"></div>
                </div>
                <div class="scc-prize-alternate__text">
                    <img
                        v-if="sponsor && sponsor.logo"
                        class="scc-prize-alternate__logo"
                        :src="sponsor.logo | cdn({ width: 50, height: 50 })"
                        :alt="sponsor.name + ' logo'"
                    />
                    <div>
                        <p class="scc-prize-alternate__title">{{ reference }}</p>
                        <p v-if="unitValue" class="scc-prize-alternate__value">{{ price }}</p>
                    </div>
                </div>
            </div>
            <div
                v-if="description"
                class="scc-prize-alternate__sub-container"
                :class="{ 'scc-prize-alternate__sub-container--active': showContainer }"
                @click="isMobile ? (showContainer = false) : null"
            >
                <div class="scc-prize-alternate__sub-inner-container">
                    <div class="scc-prize-alternate__button">
                        <img class="scc-prize-alternate__button-close" :src="closeIcon" alt="close icon" />
                    </div>
                    <p class="scc-prize-alternate__title h5">{{ reference }}</p>
                    <p class="scc-prize-alternate__description">{{ description }}</p>
                    <div v-if="sponsor && sponsor.name" class="scc-prize-alternate__sponsor">
                        <p class="scc-prize-alternate__sponsor-text bold">{{ sponsor.name }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './prize-alternate.scss';

export default {
    name: 'PrizeAlternate',
    props: {
        hasShadow: {
            type: Boolean,
        },
        unitValue: {
            type: Number,
            default: 0,
        },
        id: {
            type: String,
        },
        image: {
            type: String,
            default: null,
        },
        quantity: {
            type: Number,
            default: 1,
        },
        reference: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        sponsor: {
            type: Object,
            default() {
                return null;
            },
        },
        highlight: {
            type: Boolean,
        },
    },
    data() {
        return {
            closeIcon: require('@/assets/icons/close.svg'),
            showContainer: false,
        };
    },
    computed: {
        isMobile() {
            return window.innerWidth < 1024;
        },
        backgroundImage() {
            if (this.image)
                return {
                    backgroundImage: `url(${this.$cdn(this.image, { width: 800, height: 400 })})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                };
            else
                return {
                    backgroundImage: `url(${require('../../assets/default-images/prize.svg')})`,
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                };
        },
        price() {
            if (this.unitValue === 0) return undefined;
            return (
                'T.w.v. ' +
                this.cleanPrice(
                    this.unitValue.toLocaleString('nl-NL', {
                        style: 'currency',
                        currency: 'EUR',
                    })
                )
            );
        },
    },
    methods: {
        cleanPrice(price) {
            return price.replace(',00', '');
        },
    },
};
</script>
